<template>
  <md-card>
    <md-card-header data-background-color="purple">
      <h4 class="title">{{ $t('problem_description') }}</h4>
      <p class="category">{{ $t('problem_subtitle') }}</p>
    </md-card-header>
    <md-card-content>
      <md-content class="details" style="flex-flow:nowrap; overflow-y:scroll;">
        <div v-if="hasSelected()" class="details-text">
          <div>
            <a target='_blank' v-bind:href="articleLink">{{ $t('show_details') }}</a>
          </div>
          <br/>
          <div>
            <b class="text-bold">{{ $t('problem_description') }}: </b>{{ problemClass }}
          </div>
          <br/>
          <div>
            {{problemDescription }}
          </div>
          <br/>
          <div>
            <b class="text-bold">{{ $t('recommended_actions') }}: </b>
            <br/>
            <br/>
            <div style="white-space: pre-line">
              {{ recommendations }}
            </div>
            <br/>
          </div>
          <md-button class="md-primary action-button" v-on:click="action1()">{{ action1Label }}</md-button>
          <md-button class="md-primary action-button" v-on:click="action2()">{{ action2Label }}</md-button>
          <md-button class="md-primary action-button" v-on:click="action3()">{{ $t('dismiss_problem') }}</md-button>
        </div>
      </md-content>
    </md-card-content>
  </md-card>
</template>

<script>
import store from '@/store/index.js';
import api from '@/api/api';

export default {
  name: "TunerDetails",
  computed: {
    problemClass() {
      if (this.hasSelected()) {
        if (store.state.selectedOptimization.type === 0) {
          return this.$t('runner');
        } else if (store.state.selectedOptimization.type === 1) {
          return this.$t('sleeper');
        } else {
          return this.$t('untypicals');
        }
      }

      return "";
    },
    problemDescription() {
      if (this.hasSelected()) {
        if (store.state.selectedOptimization.type === 0) {
          return this.$t('problem_description_mover');
        } else if (store.state.selectedOptimization.type === 1) {
          return this.$t('problem_description_sleeper');
        } else {
          return this.$t('problem_description_unusual');
        }
      }

      return "";
    },
    recommendations() {
      if (this.hasSelected()) {
        if (store.state.selectedOptimization.type === 0) {
          return this.$t('recommendation_mover');
        } else if (store.state.selectedOptimization.type === 1) {
          return this.$t('recommendation_sleeper');
        } else {
          return this.$t('recommendation_unusual');
        }
      }

      return "";
    },
    articleLink() {
      if (this.hasSelected())
        return '#/app/article/' + store.state.selectedOptimization.customerItemId;

      return "";
    },
    action1Label() {
      if (store.state.selectedOptimization.type === 1) {
        return this.$t('reduce_quantity');
      } else {
        return this.$t('add_quantity');
      }
    },
    action2Label() {
      if (store.state.selectedOptimization.type === 1) {
        return this.$t('remove_container');
      } else {
        return this.$t('add_container');
      }
    }
  },
  methods: {
    hasSelected() {
      return (store.state.selectedOptimization !== null && store.state.selectedOptimization !== undefined  && store.state.selectedOptimization.state === 0);
    },
    action1() {
      let id = store.state.selectedOptimization.id;
      let action = 0;

      if (store.state.selectedOptimization.type === 1) {
        action = 2;
      } else {
        action = 0;
      }

      api.postOptimizerAction(id, action).then((result) => {
        this.$router.go();
      });
    },
    action2() {
      let id = store.state.selectedOptimization.id;
      let action = 0;

      if (store.state.selectedOptimization.type === 1) {
        action = 3;
      } else {
        action = 1;
      }

      api.postOptimizerAction(id, action).then((result) => {
        this.$router.go();
      });
    },
    action3() {
      let id = store.state.selectedOptimization.id;
      let action = 4;

      api.postOptimizerAction(id, action).then((result) => {
        this.$router.go();
      });
    }
  }
}
</script>

<style scoped>
.details {
  height: 395px;
  padding-top: 10px;
}
.details-text {
  margin-bottom: 10px;
}
.action-button {
  margin-right: 20px;
}
</style>
